module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"MenuHorizontal":{"heading":"Kategorie"}},"en":{"MenuHorizontal":{"heading":"Category"}}}')
  delete Component.options._Ctor
}
